import * as React from "react";
import {useSelector} from "react-redux";
import moment from "moment";
import {Grid} from "@material-ui/core";
import {RootState} from "../../../reducers";
import PreviewFiles from "../../../components/Common/PreviewFiles";
import EnrollmentFileUploader from "../../../components/formInputs/EnrollmentFileUploader";
import {noop} from "../../../utils/commonUtils";


type Any = any;

interface FileType extends Any {
    name: string,
    viewTitle: string
}

type Props<T> = {
    file: T
    directory?: string // if  directory will pass through the props then we use it as the s3 bucket location by default it will search in the current login user enrollment directory
    onDelete?: (props: T) => void,
    OnView?: (props: T) => void
}

type CommonUploaderProps = {
    dir?: string;
    disabled?: boolean;
    docType: string;
    onFinish: (publicUrl: string, name: string) => Promise<void>;
    preview?: Props<FileType>;
}

const CommonUploader = ({dir, disabled, docType, onFinish, preview}: CommonUploaderProps) => {
    const [onProgress, setOnProgress] = React.useState(false);
    const fileType: string = "image/jpg, image/jpeg, image/png, application/pdf, text/pdf";
    const {user: {client, id: userId}} = useSelector((state: RootState) => state.auth);
    const clientPolicy = client && client.clientPolicies && client.clientPolicies[0];
    const enrollment = clientPolicy && clientPolicy.enrollment;
    let directory = dir || (enrollment && enrollment.id);
    const [uploadedFile, setUploadedFile] = React.useState("");
    if (preview && preview.file.name) {
        const onDelete = (props: any) => {
            setUploadedFile("")
            setOnProgress(false)
            preview.onDelete && preview.onDelete(props)
        };
        const more = disabled ? {} : {onDelete};
        return (
                <Grid className={"mt20"} item xs={12} sm={preview.file.size || 6}>
                    <PreviewFiles
                            directory={directory}
                            file={preview.file}
                            {...more}
                    />
                </Grid>
        )
    }

    // we don't render uploader in this case
    if (disabled) {
        return (
                <></>
        )
    }

    return (
            <Grid item key={uploadedFile} xs={12}>
                <div className="fileUpload mt10 mb10">
                    <EnrollmentFileUploader
                            setOnProgress={setOnProgress}
                            onProgress={onProgress}
                            exactFileName={`${(docType.toUpperCase() + '_' + moment().format("DD-MM-YYYY HH:mm:ss")).replace(/ /g, "_")}`}
                            dirName={directory}
                            dirType={"documents"}
                            fileType={fileType}
                            width={15000}
                            height={15000}
                            content={`Upload ${docType}`}
                            onFinish={(publicUrl: string, name: any) => {
                                setUploadedFile(name)
                                onFinish(publicUrl, name).then();
                            }}
                    />
                </div>
            </Grid>
    )
}

export default CommonUploader;